function cov_22uz477idd() {
  var path = "/app/src/components/shadow-view/utils.ts";
  var hash = "341ee84444e514aac626764c0fb3b33360b6bce4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/shadow-view/utils.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 35
        },
        end: {
          line: 4,
          column: 72
        }
      },
      "1": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 72
        }
      },
      "2": {
        start: {
          line: 4,
          column: 50
        },
        end: {
          line: 4,
          column: 71
        }
      },
      "3": {
        start: {
          line: 6,
          column: 23
        },
        end: {
          line: 7,
          column: 66
        }
      },
      "4": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 66
        }
      },
      "5": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 13,
          column: 3
        }
      },
      "6": {
        start: {
          line: 10,
          column: 37
        },
        end: {
          line: 13,
          column: 3
        }
      },
      "7": {
        start: {
          line: 11,
          column: 22
        },
        end: {
          line: 11,
          column: 42
        }
      },
      "8": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 39
        }
      },
      "9": {
        start: {
          line: 15,
          column: 36
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "10": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 19,
          column: 78
        }
      },
      "11": {
        start: {
          line: 19,
          column: 44
        },
        end: {
          line: 19,
          column: 78
        }
      },
      "12": {
        start: {
          line: 21,
          column: 28
        },
        end: {
          line: 36,
          column: 1
        }
      },
      "13": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 32,
          column: 14
        }
      },
      "14": {
        start: {
          line: 34,
          column: 22
        },
        end: {
          line: 34,
          column: 38
        }
      },
      "15": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 35,
          column: 55
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 35
          },
          end: {
            line: 3,
            column: 36
          }
        },
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 72
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 4,
            column: 40
          },
          end: {
            line: 4,
            column: 41
          }
        },
        loc: {
          start: {
            line: 4,
            column: 50
          },
          end: {
            line: 4,
            column: 71
          }
        },
        line: 4
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 24
          }
        },
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 66
          }
        },
        line: 7
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 37
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 10,
            column: 37
          },
          end: {
            line: 10,
            column: 38
          }
        },
        loc: {
          start: {
            line: 10,
            column: 56
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 10
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 19,
            column: 23
          }
        },
        loc: {
          start: {
            line: 19,
            column: 44
          },
          end: {
            line: 19,
            column: 78
          }
        },
        line: 19
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 21,
            column: 28
          },
          end: {
            line: 21,
            column: 29
          }
        },
        loc: {
          start: {
            line: 24,
            column: 5
          },
          end: {
            line: 36,
            column: 1
          }
        },
        line: 24
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 28
          }
        }, {
          start: {
            line: 16,
            column: 32
          },
          end: {
            line: 16,
            column: 71
          }
        }],
        line: 16
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "341ee84444e514aac626764c0fb3b33360b6bce4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22uz477idd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_22uz477idd();
import { SHADOW_VIEW_INITIAL_PROPERTIES } from './constants';
cov_22uz477idd().s[0]++;
var getActualInitialProperties = function getActualInitialProperties(inheritedProps) {
  cov_22uz477idd().f[0]++;
  cov_22uz477idd().s[1]++;
  return SHADOW_VIEW_INITIAL_PROPERTIES.filter(function (prop) {
    cov_22uz477idd().f[1]++;
    cov_22uz477idd().s[2]++;
    return !inheritedProps[prop];
  });
};
cov_22uz477idd().s[3]++;
var getTabbyStyles = function getTabbyStyles() {
  cov_22uz477idd().f[2]++;
  cov_22uz477idd().s[4]++;
  return Array.from(document.querySelectorAll('style[data-app="tabby"]'));
};
cov_22uz477idd().s[5]++;
var cloneStylesToShadowDom = function cloneStylesToShadowDom(shadowRoot) {
  cov_22uz477idd().f[3]++;
  cov_22uz477idd().s[6]++;
  return function (node) {
    cov_22uz477idd().f[4]++;
    var nodeClone = (cov_22uz477idd().s[7]++, node.cloneNode(true));
    cov_22uz477idd().s[8]++;
    shadowRoot === null || shadowRoot === void 0 || shadowRoot.appendChild(nodeClone);
  };
};
export var isShadowDomAvailable = (cov_22uz477idd().s[9]++, Boolean((cov_22uz477idd().b[0][0]++, document.head.attachShadow) || (cov_22uz477idd().b[0][1]++, document.head.createShadowRoot)));
cov_22uz477idd().s[10]++;
var resetProperty = function resetProperty(property) {
  cov_22uz477idd().f[5]++;
  cov_22uz477idd().s[11]++;
  return "".concat(property, ": initial !important;");
};
cov_22uz477idd().s[12]++;
export var attachStyles = function attachStyles(element, recordOfInheritedProperties) {
  cov_22uz477idd().f[6]++;
  cov_22uz477idd().s[13]++;
  element.innerHTML += "\n    <style>\n      :host {\n        ".concat(getActualInitialProperties(recordOfInheritedProperties).map(resetProperty).join(''), "\n      }\n    </style>");
  var tabbyStyles = (cov_22uz477idd().s[14]++, getTabbyStyles());
  cov_22uz477idd().s[15]++;
  tabbyStyles.forEach(cloneStylesToShadowDom(element));
};